<!--upcash-->
<template>
  <div>
    <!-- 注册弹窗  登录框-->
    <component :is="islogon" :data="logonData" @close="islogon = ''" />
    <div class="activity_bg" v-if="cashoff"></div>
    <div class="activity" v-if="cashoff">
      <div class="activity_conent">
        <img src="../../assets/image/indexactivity/t3.png" width="445" height="348" alt="">
      </div>
      <div class="activity_btn">
        <img src="../../assets/image/indexactivity/t1.png" width="248" height="67" alt="" @click="isnewuser" />
      </div>
      <div class="activity_gb" @click="guanbi">
        <img src="../../assets/image/indexactivity/t2.png" width="56" height="56" alt="">
      </div>
      <div class="fireworks" style="top: 15%;left: 10%;"><img src="../../assets/image/upcash/6.png" width="156"
          height="156" alt=""></div>
      <div class="fireworkst" style="top: 6%;right: 20%;"><img src="../../assets/image/upcash/7.png" width="156"
          height="156" alt=""></div>
      <div class="fireworksx" style="top: 30%;right: 6%;"><img src="../../assets/image/upcash/8.png" width="156"
          height="156" alt=""></div>
    </div>
  </div>
</template>

<script>

import looklogon from '../../views/classUtils/signin/logon' // 调取登录弹窗
export default {
  name: "activity",
  props: {
    iscashobj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    looklogon
  },
  data() {
    return {
      cashoff: false,
      // 登录有关 开始
      islogon: '', // 组件名
      logonData: {}, // 传参
      // 登录有关 结束
    };
  },

  created() {
    this.$nextTick(() => {
      // let nan = localStorage.getItem('activityNan');
      // console.log(nan,"nannannannannan");
      // if(!nan && nan != 1){ // 没有则 打开 并 将值设置成1
      //   this.cashoff = true;
      //   localStorage.setItem("activityNan", 1);
      // }
    })
  },
  mounted() { },
  computed: {},
  methods: {
    // 关闭弹窗
    guanbi() {
      this.cashoff = false;
      localStorage.setItem("activityNan", 1);
    },

    isnewuser(params) {
      this.islogon = 'looklogon';
      this.guanbi();
      this.logonData = {
        tanchu: 1
      }
    },
  },
};
</script>

<style scoped>
.activity {
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}


.activity_bg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: rgba(0, 0, 0, .6);
}

.activity_gb {
  position: absolute;
  top: 0;
  right: -30px;
  cursor: pointer;
  z-index: 11;
}

.activity_btn {
  padding-left: 36px;
  cursor: pointer;
  position: absolute;
  left: 50%;
  bottom: -80px;
  transform: translate(-50%, -0%);
  z-index: 11;
}


.fireworks {
  transform: scale(0);
  animation: fireworks 1s 1s infinite;
  position: absolute;
}

.fireworksx {
  transform: scale(0);
  animation: fireworksx 2s 1s infinite;
  position: absolute;
}

.fireworkst {
  transform: scale(0);
  animation: fireworkst 3s 1s infinite;
  position: absolute;
}

@keyframes fireworks {
  0% {
    transform: scale(0);
  }

  80% {
    transform: scale(2);
  }

  100% {
    opacity: 0;
  }
}

@keyframes fireworksx {
  0% {
    transform: scale(0);
  }

  80% {
    transform: scale(3);
  }

  100% {
    opacity: 0;
  }
}

@keyframes fireworkst {
  0% {
    transform: scale(0);
  }

  80% {
    transform: scale(2);
  }

  100% {
    opacity: 0;
  }
}


@keyframes anddonke {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xmgc/activity.vue